import { render, staticRenderFns } from "./EdsAccordion.vue?vue&type=template&id=b2e40714&"
import script from "./EdsAccordion.vue?vue&type=script&lang=js&"
export * from "./EdsAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports